import React from "react";

export const ChevronDown: React.FC<any> = () => (

	<g stroke="none" strokeWidth="1" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			transform="translate(13.092684, 8.500000) scale(-1, 1) rotate(90.000000) translate(-13.092684, -8.500000) "
			points="5.07239656 -1.95140481 6.92760344 -4.04859519 21.1129719 8.5 6.92760344 21.0485952 5.07239656 18.9514048 16.887 8.5"
		></polygon>
	</g>
);

export const ChevronUp: React.FC<any> = () => (
	<g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			transform="translate(13.092684, 8.500000) scale(-1, 1) rotate(-90.000000) translate(-13.092684, -8.500000) "
			points="5.07239656 -1.95140481 6.92760344 -4.04859519 21.1129719 8.5 6.92760344 21.0485952 5.07239656 18.9514048 16.887 8.5"
		></polygon>
	</g>
);